import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, switchMap, tap, catchError, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import * as AppActions from './app.actions';
import { AuthService } from '../../services/auth/auth.service';
import { DosespotService } from '../../services/dosespot/dosespot.service';
import { resolveOrgFromUrl, setOrgQueryParam, SELECTED_LAYOUT_KEY } from './layout-org.util';

@Injectable()
export class AppEffects {
  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private notification: NzNotificationService,
    private dosespotService: DosespotService
  ) { }

  selectLayout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppActions.selectLayout),
        tap(({ layout }) => {
          localStorage.setItem(SELECTED_LAYOUT_KEY, layout);
          setOrgQueryParam(layout);
          window.location.reload();
        })
      ),
    {
      dispatch: false
    }
  );

  loadLayouts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loadAppLayouts),
      exhaustMap(({ user }) =>
        this.authService.getAppLayouts().pipe(
          map(appLayouts => {
            const resolvedOrg = resolveOrgFromUrl(appLayouts);

            let layout = resolvedOrg || localStorage.getItem(SELECTED_LAYOUT_KEY);
            let activeLayoutIndex = appLayouts.findIndex(
              x => x.organization === layout
            );
            if (activeLayoutIndex === -1) {
              activeLayoutIndex = 0;
              layout = appLayouts[0].organization;
            }
            localStorage.setItem(SELECTED_LAYOUT_KEY, layout);
            setOrgQueryParam(layout);
            return { appLayouts, activeLayoutIndex };
          }),
          tap(({ appLayouts, activeLayoutIndex }) => {
            const activeOrg = appLayouts[activeLayoutIndex].organization;
            this.dosespotService.updateClinicianId(
              user.extras?.[`${activeOrg}__dosespotClinicianId`]
            );
            this.dosespotService.updateClinicId(
              appLayouts[activeLayoutIndex].dosespotClinicId
            );
            this.dosespotService.updateSsoUrl(
              appLayouts[activeLayoutIndex].dosespotUiUrl
            );
          }),
          switchMap(({ appLayouts, activeLayoutIndex }) => [
            AppActions.loadAppLayoutsSuccess({ appLayouts }),
            AppActions.setActiveLayout({ activeLayoutIndex })
          ]),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error loading app meta data.');
            return of(AppActions.loadAppLayoutsFailure({ error }));
          })
        )
      )
    )
  );
}
